"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AdPersona_1 = require("./AdPersona");
var ItemHeaderInfobar_1 = require("./ItemHeaderInfobar");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdReadingPane.scss');
var classNames = require('classnames/bind').bind(styles);
var ItemHeader = /** @class */ (function (_super) {
    tslib_1.__extends(ItemHeader, _super);
    function ItemHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemHeader.prototype.render = function () {
        return (React.createElement("div", { className: classNames(styles.itemHeaderContainer) },
            React.createElement(AdPersona_1.default, { name: this.props.adSender, imageUrl: this.props.adFavIconurl }),
            React.createElement(ItemHeaderInfobar_1.default, null)));
    };
    ItemHeader = tslib_1.__decorate([
        mobx_react_1.observer
    ], ItemHeader);
    return ItemHeader;
}(React.Component));
exports.default = ItemHeader;
//# sourceMappingURL=ItemHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-readingpane-view/lib/components/ItemHeader.js
// module id = 5556
// module chunks = 17